export default __webpack_public_path__ + "static/media/logo.6c8e0676.svg";